/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "actions";
import "components/elements/main/index.scss";
import {Box, Button, IconButton, useMediaQuery, useTheme} from "@mui/material";
import {FlexBetween, FlexBox} from "components/flex-box";
import MockShopHeader from "components/elements/main/MockShopHeader";

import { Avatar, Card, Typography } from "@mui/material";
import { H1, H2, H5, H6 } from "components/CustomTypography";
import {getLogo, openGoogleMapLocation, openInstagram, openWhatsApp} from "helpers/utils";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import * as ActionTypes from "constants/ActionTypes";
import CircularProgress from "@mui/material/CircularProgress";
import PlaceIcon from "@mui/icons-material/Place";
import ButtonComponent from "../../../../Button";
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const ShopHeaderMiniOverlay = (props) => {

    const {
        serviceError, reqStatus, isLoading, isLoadingBootInfo, bootupInfo, userMainGetShopInfoById,
        history, shopdetail, userMainAddStoreToFavlist, shopId
    } = props;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // < 600px
  const isTablet = useMediaQuery(theme.breakpoints.down('md')); // < 900px

  const [state] = useState({
    layoutColumns: 3,
  });

    const handleBackHome = () => {
        history.push(`/shops`);
    };

    const handleShopButtonClick = () => {
        history.push(`/shop/${shopdetail.id}`);
    };

    useEffect(() => {
        userMainGetShopInfoById(shopId);
    }, []);

    useEffect(() => {
        switch (reqStatus) {
            case ActionTypes.USER_MAIN_ADD_STORE_TO_FAVLIST_SUCCESS:
                userMainGetShopInfoById(shopId);
                break;
            default:
                break;
        }
    }, [serviceError, reqStatus]);


    const addShopFavourite = () => {
        userMainAddStoreToFavlist(shopdetail.id);
    };

    const openGoogleMap = () => {
        openGoogleMapLocation(shopdetail.location);
    };

    // Responsive sizing values
    const avatarSize = isMobile ? 60 : isTablet ? 70 : 80;
    const avatarWidth = isMobile ? "30%" : "25%";
    const contentWidth = isMobile ? "70%" : "75%";
    const iconSize = isMobile ? "medium" : "large";
    const buttonSize = isMobile ? "small" : "medium";
    const titleVariant = isMobile ? "h6" : isTablet ? "h5" : "h5";
    const areaVariant = isMobile ? "body2" : "h6";
    const padding = isMobile ? "2px 2px" : "4px 4px";
    const borderWidth = isMobile ? '2px' : '3px';
    const iconPadding = isMobile ? 2 : 3;
    const buttonMargin = isMobile ? 1 : 2;
    
    return (
        <Box mb={2}
        >

            <Box
                sx={{
                    display: "flex",
                    p: padding,
                    height: "100%",
                    alignItems: "center",
                    bgcolor: "#E53E3E",
                    flexWrap: { xs: 'nowrap', sm: 'nowrap' }
                }}
            >
                {isLoading ? <Box width="25%" sx={{
                        height: avatarSize,
                        m: 2,
                        justifyContent: "center",
                        alignItems: "center",
                        }} width="100%"><CircularProgress sx={{ color: '#fff' }} size={isMobile ? 30 : 40} />
                    </Box>
                    : <>
                                <Box width={avatarWidth} onClick={handleShopButtonClick} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <Avatar
                                        src={getLogo(shopdetail.logo)}
                                        sx={{
                                            height: avatarSize,
                                            width: avatarSize,
                                            mb: { xs: 1, sm: 2 },
                                            border: `${borderWidth} solid white`,
                                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                            cursor: 'pointer'
                                        }}
                                    />
                                </Box>
                                <Box width={contentWidth} sx={{ pl: { xs: 0.5, sm: 1 } }}>
                                    <Box width="100%" alignItems="left" onClick={handleShopButtonClick} sx={{ cursor: 'pointer' }}>
                                        <Typography
                                            variant={titleVariant}
                                            sx={{
                                                fontWeight: 'bold',
                                                textAlign: 'left',
                                                mb: { xs: 0.5, sm: 1 },
                                                mt: { xs: 1, sm: 1.5 },
                                                color: 'white',
                                                fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2.0rem' }
                                            }}
                                        >
                                            {shopdetail.title}
                                        </Typography>
                                        {shopdetail.area && (
                                            <Typography
                                                variant={areaVariant}
                                                sx={{
                                                    color: 'rgba(255,255,255,0.8)',
                                                    textAlign: 'left',
                                                    fontSize: { xs: '0.75rem', sm: '0.875rem', md: '1rem' }
                                                }}
                                            >
                                                {shopdetail.area}
                                            </Typography>
                                        )}
                                    </Box>
                                    <FlexBox width="100%" alignItems="center" sx={{ flexWrap: { xs: 'wrap', sm: 'nowrap' } }}>
                                        <FlexBox width="40%"  sx={{ justifyContent: 'flex-start' }}>
                                            <IconButton 
                                                sx={{ pr: iconPadding, paddingLeft: 0, color: 'white' }}
                                                onClick={() => openGoogleMap()}
                                                size={iconSize}
                                            >
                                                <PlaceIcon fontSize={iconSize} />
                                            </IconButton>
                                            {shopdetail.instahandle &&
                                                <IconButton 
                                                    sx={{ pr: iconPadding, paddingLeft: 0, color: 'white' }}
                                                    onClick={() => openInstagram(shopdetail.instahandle)}
                                                    size={iconSize}
                                                >
                                                    <InstagramIcon fontSize={iconSize} />
                                                </IconButton>
                                            }
                                            {shopdetail.whatsapphandle &&
                                                <IconButton 
                                                    sx={{ pr: iconPadding, paddingLeft: 0, color: 'white' }}
                                                    onClick={() => openWhatsApp(shopdetail.whatsapphandle)}
                                                    size={iconSize}
                                                >
                                                    <WhatsAppIcon fontSize={iconSize} />
                                                </IconButton>
                                            }
                                        </FlexBox>
                                        <FlexBox width="60%" sx={{ justifyContent: 'flex-start' }}>
                                        <Box width={{ xs: '48%', sm: '30%' }} alignItems="left">
                                            {parseInt(shopdetail.fav) > 0 ?
                                                <Box
                                                    sx={{
                                                        mt: { xs: 0.5, sm: buttonMargin },
                                                        mb: { xs: 0.5, sm: buttonMargin },
                                                        p: { xs: 1, sm: 2 },
                                                        border: `${borderWidth} solid primary`,
                                                        minWidth: 'auto',
                                                        color: 'white',
                                                        backgroundColor: 'primary',
                                                        fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                                        textAlign: 'center'
                                                    }}>
                                                    <b>{isMobile ? 'Following' : 'Following'}</b>
                                                </Box>
                                                :
                                                isLoading ? <CircularProgress size={isMobile ? "0.8rem" : "1rem"} sx={{ color: 'white' }}/> : <>
                                                    <ButtonComponent
                                                        sx={{
                                                            mt: { xs: 0.5, sm: buttonMargin },
                                                            mb: { xs: 0.5, sm: buttonMargin },
                                                            border: `${borderWidth} solid white`,
                                                            minWidth: 'auto',
                                                            color: 'white',
                                                            backgroundColor: 'primary',
                                                            fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.875rem' },
                                                            px: { xs: 1, sm: 2 },
                                                            py: { xs: 0.5, sm: 1 }
                                                        }}
                                                        type="primary"
                                                        variant="contained"
                                                        name={isMobile ? "Follow" : "Follow us!"}
                                                        size={buttonSize}
                                                        onClick={() => addShopFavourite()}
                                                    />
                                                </>
                                            }
                                        </Box>
                                        <Box width={{ xs: '48%', sm: '30%' }} alignItems="left">
                                            <ButtonComponent
                                                sx={{
                                                    mt: { xs: 0.5, sm: buttonMargin },
                                                    mb: { xs: 0.5, sm: buttonMargin },
                                                    border: `${borderWidth} solid white`,
                                                    color: 'white',
                                                    minWidth: 'auto',
                                                    fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.875rem' },
                                                    px: { xs: 1, sm: 2 },
                                                    py: { xs: 0.5, sm: 1 }
                                                }}
                                                type="primary"
                                                variant="contained"
                                                name="View >"
                                                size={buttonSize}
                                                onClick={handleShopButtonClick}
                                            />
                                        </Box>
                                        </FlexBox>
                                    </FlexBox>
                                </Box>
                    </>}
            </Box>
        </Box>
    );
};

ShopHeaderMiniOverlay.propTypes = {
  bootupInfo: PropTypes.objectOf(PropTypes.any).isRequired,
};

// Mapping Props and State.
const shopHeaderMiniOverlay = connect(
  ({ bootupInfo, userMainShops }) => ({
    bootupInfo,
      isLoadingBootInfo: bootupInfo.isLoading,
    reqStatus: userMainShops.reqStatus,
    isLoading: userMainShops.isLoading,
    serviceError: userMainShops.serviceError,
      shopdetail: userMainShops.shopDetail,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(ShopHeaderMiniOverlay);

export { shopHeaderMiniOverlay as default };
